import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './About.css';
import SubHero from '../../components/SubHero/SubHero';
import HeroImage from '../../images/hero1.jpg';
import teamImage from '../../images/team-marketing-services.jpg';
import Team from '../../components/Teams/Team';
import Tag from '../../components/Tag/Tag';
import { FaUserGraduate, FaCheckCircle } from "react-icons/fa";
import { BsFillPeopleFill } from "react-icons/bs";
import { FaFloppyDisk } from "react-icons/fa6";
import CommonCard from '../../components/CommonCard/CommonCard';


const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)

    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });
  }, []);



  const about_values = [
    {
      title: 'Innovation',
      msg: 'We stay ahead of digital trends to bring fresh, forward-thinking solutions to every project.',
      icon: <FaUserGraduate />
    },
    {
      title: 'Excellence',
      msg: "We're committed to delivering exceptional quality and exceeding expectations in everything we do.",
      icon: <FaCheckCircle />
    },
    {
      title: 'Partnership',
      msg: "We build authentic relationships with our clients, treating their goals as our own.",
      icon: <BsFillPeopleFill />
    },
    {
      title: 'Results',
      msg: "We focus on delivering measurable outcomes that drive real business growth for our clients.",
      icon: <FaFloppyDisk />
    },
  ]

  const difference_data = [
    {
      tag: "Strategy-Led Execution",
      msg: "Every campaign is backed by research and tailored to your specific business goals."
    },
    {
      tag: "Creative That Connects",
      msg: "Our content doesn't just look good — it performs. We create content that tells your story, builds your community, and drives action."
    },
    {
      tag: "Results You Can Measure",
      msg: "From page growth to ad ROI, we track everything and deliver clear, actionable reports."
    },
  ]

  const whoWeServe_data = [
    "Business owners & startups",
	  "Content creators & public figures",
	  "NGOs & institutions",
	  "Large brands in need of consistent online growth",
  ]




  return (
    <div className="About">
      {/* Hero Section */}
      <SubHero 
        title="About Us"
        subtitle="Empowering Brands with Strategy, Creativity, and Results"
        image={HeroImage}
      />


      <div className='BODY'>
        {/* Our Story Section */}
        <div className="About-story">
          <div className="About-container">
            <div className="About-story-grid">
              <div className="About-story-content" data-aos="fade-up">

                <Tag title="Our Story" variant="primary" />
                <p className="About-text text-1">
                  At Oma Media Space Limited, we are more than just a digital marketing agency — we are your brand's growth partner in the ever-evolving online space. Our mission is to help businesses and talents thrive by offering powerful, data-driven marketing solutions that drive visibility, engagement, and real conversions.
                </p>
                <p className="About-text text-1">
                Founded with a vision to reshape how brands show up and scale online, we combine strategy, creativity, and performance to deliver results that matter. Whether you're a startup trying to break through the noise or a large brand looking to expand your digital footprint, we're here to help you tell your story the right way — and to the right people.
                </p>
                <div className="About-stats">
                  <div className="About-stat" data-aos="fade-up" data-aos-delay="100">
                    <div className="About-stat-number header-1">4+</div>
                    <div className="About-stat-label text-1">Years Experience</div>
                  </div>
                  <div className="About-stat" data-aos="fade-up" data-aos-delay="200">
                    <div className="About-stat-number header-1">100+</div>
                    <div className="About-stat-label text-1">Happy Clients</div>
                  </div>
                  <div className="About-stat" data-aos="fade-up" data-aos-delay="300">
                    <div className="About-stat-number header-1">18</div>
                    <div className="About-stat-label text-1">Team Members</div>
                  </div>
                </div>
              </div>
              <div className="About-story-image-container" data-aos="fade-up">
                <img src={teamImage} alt="Our team at work" className="About-story-image" />
              </div>
            </div>
          </div>
        </div>

        {/* Our Values Section */}
        <div className="About-values">
          <div className="About-container">
            <Tag title="Our Core Values" variant="primary" />

            <div className="About-values-grid">
              <CommonCard card_data={about_values} />
            </div>
          </div>
        </div>



        <section className='difference'>
          <div className='difference-container'>
            <h2 className='difference-title header-2'> What Makes Us Different? </h2>
              {
                difference_data.map((difference, diff_id) => {
                  return (
                    <aside className='single_difference text-1' key={diff_id}>
                      <p className='diff-tag'> {difference.tag} </p>
                      <p className='diff-msg'> {difference.msg} </p>
                    </aside>
                  )
                })
              }

            <h2 className='whoWeServe-title header-2'> Who do we serve? </h2>
            <ol>
              {
                whoWeServe_data.map((who, who_id) => {
                  return (
                    <li className='single-org text-1' key={who_id}> {who} </li>
                  )
                })
              }

            </ol>
          </div>
        </section>

        <Team />
      </div>

    </div>
  );
};

export default AboutPage;